import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/search.svg'
import _imports_1 from '@/assets/images/arrow-left.svg'


const _withScopeId = n => (_pushScopeId("data-v-eb338fd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "search-desktop" }
const _hoisted_2 = ["placeholder", "maxlength"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "search icon"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"20px"},
  alt: "close"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "position-relative flex-grow-1" }
const _hoisted_10 = ["placeholder", "maxlength"]
const _hoisted_11 = ["onClick"]

import { translate } from '@/languages/i18n'
import { ref, watch, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { throttle, omit } from 'lodash'
import { WAITING_SUBMIT_TIME_OUT, MAX_LENGTH_CONTENT_SEARCH } from '@/constants/number'
import { POST_STORE, ROOT_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  placeholder: {
    type: String,
    default: translate('search'),
  },
  keyword: String,
},
  setup(__props) {

const props = __props


const store = useStore()
const router = useRouter()
const route = useRoute()
// 2022/09/16 CW-Phuong Fix for horizontal fixing#7: SF10
let searchText = ref<string>(route.query.keyword)

const isPhone = computed<boolean>(() => store.getters[ROOT_STORE.GETTERS.CHECK_PHONE_DEVICE])
const openSearchFormMobile = ref<boolean>(false)
const inputSearchMobile = ref(null)
const checkSearchFormMobile = () => {
  // デスクトップ版で検索画面が開かないよう制御する
  if (isPhone.value) {
    openSearchFormMobile.value = true
    inputSearchMobile.value.focus()
  }
}

const handleSearch = throttle(async (page: number) => {
  openSearchFormMobile.value = false

  if (isPhone.value) {
    inputSearchMobile.value.blur()
  }

  if (checkRouter()) {
    await store.dispatch(POST_STORE.ACTIONS.GET_POSTS, { change: true, community_id: route?.params?.id, params: { ...route?.query, ...(page && { page }) } })
    return
  }
  let queryObj = { ...route?.query }
  if (searchText.value !== '') {
    queryObj = { ...route?.query, [props.keyword]: searchText.value }
  } else {
    queryObj = omit(queryObj, `${props.keyword}`)
  }
  router.push({ path: route.path, query: queryObj })
}, WAITING_SUBMIT_TIME_OUT)

watch(
  () => route.query,
  () => {
    if (!route.query.keyword) {
      searchText.value = ''
    }
  }
)

// モーダルを開いた際の画面スクロールを禁止する
const preventDefault = (e) => {
  e.preventDefault()
}
watch(openSearchFormMobile, () => {
  if (openSearchFormMobile.value) {
    window.addEventListener('touchmove', preventDefault, { passive: false })
  } else {
    window.removeEventListener('touchmove', preventDefault, { passive: false })
  }
})

const checkRouter = () => {
  let key_search = route.query.keyword ?? ''
  if (searchText.value === key_search) return true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: _normalizeClass({ 'search-container mt-lg-5 mt-4 position-relative': !_unref(isPhone) }),
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleSearch) && _unref(handleSearch)(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: __props.placeholder,
        maxlength: _unref(MAX_LENGTH_CONTENT_SEARCH),
        onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_unref(handleSearch) && _unref(handleSearch)(...args)), ["enter"])),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(searchText) ? (searchText).value = $event : searchText = $event)),
        class: "form-control w-100 shadow position-absolute"
      }, null, 40, _hoisted_2), [
        [
          _vModelText,
          _unref(searchText),
          void 0,
          { trim: true }
        ]
      ]),
      _createElementVNode("img", {
        src: _imports_0,
        alt: "search icon",
        class: "img-container position-absolute d-flex justify-content-center align-items-center",
        onClick: _unref(handleSearch)
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", { id: "search-mobile" }, [
      _createElementVNode("button", {
        type: "button",
        class: "bg-white shadow",
        onClick: checkSearchFormMobile
      }, _hoisted_5)
    ]),
    _createElementVNode("nav", {
      id: "nav-search-mobile",
      class: _normalizeClass(['search-container', 'bg-white', 'px-3', 'pt-4', { active: openSearchFormMobile.value }])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          id: "close-nav-search-mobile",
          class: "align-self-center me-3",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (openSearchFormMobile.value = false))
        }, _hoisted_8),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: __props.placeholder,
            maxlength: _unref(MAX_LENGTH_CONTENT_SEARCH),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_unref(handleSearch) && _unref(handleSearch)(...args)), ["enter"])),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(searchText) ? (searchText).value = $event : searchText = $event)),
            class: "form-control w-100 shadow position-absolute",
            ref: (_value, _refs) => {
              _refs['inputSearchMobile'] = _value
              inputSearchMobile.value = _value
            }
          }, null, 40, _hoisted_10), [
            [
              _vModelText,
              _unref(searchText),
              void 0,
              { trim: true }
            ]
          ]),
          _createElementVNode("img", {
            src: _imports_0,
            alt: "search icon",
            class: "img-container position-absolute d-flex justify-content-center align-items-center",
            onClick: _unref(handleSearch)
          }, null, 8, _hoisted_11)
        ])
      ])
    ], 2)
  ], 34))
}
}

})